// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__1kxu0","rowsWrapper":"style_rowsWrapper__1l14u","rowWrapper":"style_rowWrapper__JptYf"};